var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'info-box': true, 'warning-box': _vm.warning}},[_c('div',{staticClass:"box-icon"},[_c('icon',{attrs:{"icon":['fal', 'exclamation-triangle']}})],1),_c('div',{staticClass:"box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }